import { saveAs } from "file-saver";

const escapeCsvCell = (value: any) => {
  const stringValue = String(value ?? "");
  if (/[",\n\r]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

interface ExportBeAwareTableOptions {
  tableHeadings: { [key: string]: string };
  rows: any[];
  filename: string;
  // Optional per-cell resolver; defaults to the raw mapped row value.
  getCellValue?: (key: string, row: any) => any;
}

export const exportBeAwareTableToCSV = ({
  tableHeadings,
  rows,
  filename,
  getCellValue,
}: ExportBeAwareTableOptions) => {
  const entries = Object.entries(tableHeadings);
  const resolve = (key: string, row: any) =>
    getCellValue ? getCellValue(key, row) : (row[key] ?? "");

  const csvRows = [
    entries.map(([, label]) => escapeCsvCell(label)).join(","),
    ...rows.map((row) =>
      entries.map(([key]) => escapeCsvCell(resolve(key, row))).join(","),
    ),
  ];

  const blob = new Blob([csvRows.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  saveAs(blob, `${filename}.csv`);
};
